

import { Component, Vue, Watch } from 'vue-property-decorator';
import availableRoutes from '@/plugins/availableRoutes';
import Api from '@/assets/ts/Api';
import { Message } from '@/clients/omb-api';
import getRole from '@/plugins/roleHandler';
import { ROLE } from '@/assets/ts/enum/role';
import InputButton from '@/components/input/InputButton.vue';
import OfflineActionHandler from '@/assets/ts/OfflineActionHandler';
import { MESSAGE_TYPE } from '@/assets/ts/enum/message_type';

@Component({
    components: { InputButton },
})
export default class Header extends Vue {

    private ROLE = ROLE;

    private routeToFeatures: string = availableRoutes.features;
    private routeToMessages: string = availableRoutes.messages;
    private messages: Message[] = [];
    private role = ROLE.GUEST;

    private get messageCount(): number {
        return this.messages.length;
    }

    private get messageCountNewRepairs(): number {
        return this.messages.filter((m) => m.type === MESSAGE_TYPE.NEW_REPAIR).length;
    }

    private get hasPrintButton(): boolean {
        const a = availableRoutes;
        const routeNames = [
            a.projects,
            a.projectGroups,
            a.plastics,
            a.steel,
            a.doors,
            a.facades,
            a.windows,
            a.tin,
            a.bazQuadra1,
            a.bazQuadra2,
            a.bazCometTekna,
            a.isomat,
            a.assembly,
        ];
        return routeNames.includes(this.$route.name || '');
    }

    private get hasRefreshButton(): boolean {
        const a = availableRoutes;
        const routeNames = [
            a.projects,
            a.projectGroups,
            a.plastics,
            a.steel,
            a.doors,
            a.facades,
            a.windows,
            a.tin,
            a.bazQuadra1,
            a.bazQuadra2,
            a.bazCometTekna,
            a.isomat,
            a.assembly,
            a.projectGroupDetails,
            a.projectGroupDetailsArchive,
        ];
        return routeNames.includes(this.$route.name || '');
    }

    private get hasCreateProjectButton(): boolean {
        const routeNames = [
            availableRoutes.projects,
            availableRoutes.projectGroupDetails,
        ];
        return routeNames.includes(this.$route.name || '') && [ROLE.ADMINISTRATOR, ROLE.PLANNING, ROLE.EPLANNING].includes(this.role);
    }

    private get hasCreateProjectGroupButton(): boolean {
        return this.$route.name === availableRoutes.projectGroups && [ROLE.ADMINISTRATOR, ROLE.PLANNING, ROLE.EPLANNING].includes(this.role);
    }

    private get hasCreateRepairButton(): boolean {
        return this.$route.name === availableRoutes.repairs && [ROLE.ADMINISTRATOR, ROLE.PLANNING, ROLE.EPLANNING, ROLE.EASSEMBLY].includes(this.role);
    }

    private mounted() {
        this.loadMessages();
        this.loadRole();
    }

    private async logout() {
        await Api.omb.logoutPost();
        Api.initServices('');
        localStorage.setItem('OMB_USER_ID', '');
        this.$router.push({ name: availableRoutes.login });
    }

    private async loadMessages() {
        try {
            this.messages = await Api.omb.messageGet();
        } catch (e: any) {
            if (e.status === 401) {
                Api.initServices('');
                this.$router.push({ name: availableRoutes.login });
            }
        }
    }

    private async loadRole() {
        this.role = await getRole();
    }

    @Watch('$route', {
        immediate: true,
        deep: true,
    })
    onUrlChange(): void {
        this.loadMessages();
    }

    private print() {
        this.$root.$emit('print');
    }

    private reload() {
        if (!window.navigator.onLine) {
            OfflineActionHandler.handle('Seite aktualisieren');
            return;
        }

        this.$router.go(0);
    }

    private openNewProjectDialog() {
        if (!window.navigator.onLine) {
            OfflineActionHandler.handle('Bauabschnitt erstellen');
            return;
        }

        this.$root.$emit('openNewProjectDialog');
    }

    private openNewProjectGroupDialog() {
        if (!window.navigator.onLine) {
            OfflineActionHandler.handle('Bauvorhaben erstellen');
            return;
        }

        this.$root.$emit('openNewProjectGroupDialog');
    }

    private openNewRepairDialog() {
        if (!window.navigator.onLine) {
            OfflineActionHandler.handle('Reparatur erstellen');
            return;
        }

        this.$root.$emit('openNewRepairDialog');
    }

}
